import { useRef, useState } from "react"
import { Cropper } from "react-advanced-cropper"
import "react-advanced-cropper/dist/style.css"
import IconArrowRight from "../images/icon-arrow-right.svg?react"
import { getCroppedImg } from "./utils.js"

export default function CropView({ screenshot, onCrop, onCancel }) {
  const cropperRef = useRef(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleRecognize = async () => {
    const coords = cropperRef.current?.getCoordinates()
    if (!coords) return
    setLoading(true)
    setError(null)
    try {
      const base64 = await getCroppedImg(screenshot, {
        x: coords.left,
        y: coords.top,
        width: coords.width,
        height: coords.height,
      })
      await onCrop(base64)
    } catch (err) {
      setError(err.message || "Recognition failed")
      setLoading(false)
    }
  }

  const defaultSize = ({ imageSize, visibleArea }) => {
    const area = visibleArea || imageSize
    const width = area.width * 0.8
    return { width, height: width / 2.5 }
  }

  return (
    <div className="crop-view">
      <h2 className="crop-title">Crop equation</h2>

      <Cropper
        ref={cropperRef}
        src={screenshot}
        className="crop-container"
        defaultSize={defaultSize}
        stencilProps={{ grid: false }}
      />

      <p className="crop-hint">Drag to pan. Corners to resize. Scroll to zoom.</p>

      {error && <div className="crop-error">{error}</div>}

      <div className="crop-actions">
        <button className="crop-btn-cancel" onClick={onCancel}>
          Cancel
        </button>
        <button className="solve-btn-main" onClick={handleRecognize} disabled={loading}>
          {loading ? (
            <div className="dots dots--on-gradient">
              <span />
              <span />
              <span />
            </div>
          ) : (
            <>
              <span>Recognize</span>
              <IconArrowRight width={20} height={20} />
            </>
          )}
        </button>
      </div>
    </div>
  )
}
